import api from "./api/api";

const NotificationsService = {
  get: async () => {
    try {
      const res = await api.get(`/notifications?page=1&perPage=9999`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  read: async (id: any) => {
    try {
      const res = await api.get(`/notifications/read/${id}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
};

export default NotificationsService;
